import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { readPlanIntent, clearPlanIntent, planPath } from "@/lib/plans";
export function PlanOnboardingContinuation() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    // Google returns home. Confirmation/reset routes complete their own flows.
    if (loading || !user || pathname !== "/") return;
    const plan = readPlanIntent();
    if (plan) {
      clearPlanIntent();
      navigate(planPath(plan), { replace: true });
    }
  }, [user?.id, loading, navigate, pathname]);
  return null;
}
